export const RoomPastInMs = 24 * 60 * 60 * 1_000;
